import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";

export function initialValues(state) {
  return {
    localidad: state.localidad,
    precioporkm: state.precioporkm,
    moneda: state.moneda,
    activo: state.activo,
  };
}

export function validationSchema() {
  return Yup.object({
    localidad: Yup.string().required(` ${campo_obligatorio} `),
    precioporkm: Yup.string().required(` ${campo_obligatorio} `),
    moneda: Yup.string().required(` ${campo_obligatorio} `),
  });
}
